import React, { useEffect, useState } from "react";
import Card from "../../components/Card";
import Form from "../../components/Form";
import Tabs from "../../components/Tabs";
import { UseDisclosure } from "../../hooks/use-disclosure";
import styles from "./Product.module.sass";
import Table from "./Table";
import { UseApi } from "../../hooks/use-api";
import { GetCollections } from "../../Services/lib/nft";
import TemplateModal from "../NewProduct/TemplateModal";
import CCreate from "./CreateCollection";
import { useUser } from "../../context";
import collection_ from "../../i11/Collection";

export const PageLimit = 8;

const Collection = () => {
	const { locale } = useUser();
	const types = {
		Drafts: "DRAFT",
		Published: "SCHEDULE",
	};
	const {
		isOpen: createV,
		onOpen: createO,
		onClose: createC,
	} = UseDisclosure();

	const [page, setPage_] = useState(1);
	const [total, setTotal] = useState(1);
	const [{ isLoading }, getCollections] = UseApi({
		service: GetCollections,
	});
	const [collection, setCollection] = useState([]);
	const [initial, setInitial] = useState();
	const [search, setSearch] = useState("");
	const [type, setType] = useState("Published");
	const [filter, setFilter] = useState({
		page: 1,
		limit: PageLimit,
		name: "",
		status: "SCHEDULE",
		order_direction: "ASC",
	});

	const getCollection_ = async () => {
		setCollection([]);
		const res = await getCollections(filter);
		if (res) {
			setCollection(res.list);
			setTotal(Math.ceil(res.list_count / PageLimit));
		}
	};
	useEffect(() => {
		getCollection_();
	}, [filter]);

	useEffect(() => {
		const type_ = types[type];
		if (type_ !== filter.status) {
			setFilter((p) => {
				return {
					...p,
					status: type_,
				};
			});
		}
	}, [type]);

	const setPage = (e) => {
		setPage_(e);
		if (filter.page !== e)
			setFilter((p) => {
				return {
					...p,
					page: e,
				};
			});
	};

	const set_edit = (item) => {
		const body = {
			_id: item._id,
			name: item.name || "",
			description: item.description || "",
			image: item.image || "",
			startDate: item.startDate || "",
			endDate: item.endDate || "",
			nftTemplates: item.nftTemplates,
			drawHtml: item.drawHtml || "",
		};

		for (const [key, value] of Object.entries(body)) {
			if (!value) delete body[key];
		}

		setInitial(body);
		createO();
	};

	const CloseC_ = () => {
		createC();
		setInitial();
	};

	const CloseC = () => {
		CloseC_();
		getCollection_();
	};

	const onSubmit = (e) => {
		e.preventDefault();
		if (filter.name !== search) {
			setFilter((p) => {
				return {
					...p,
					name: search,
				};
			});
		}
	};

	const prop = {
		items: collection,
		isLoading,
		page,
		total,
		getCollection_,
		setFilter,
		filter,
		set_edit,
		setPage,
	};
	return (
		<>
			<Card
				title={collection_[locale].collection}
				classTitle="title-red"
				classCardHead={styles.head}
				head={
					<>
						<Form
							placeholder={collection_[locale].search_coll}
							type="text"
							name="search"
							icon="search"
							required={false}
							value={search}
							setValue={setSearch}
							onSubmit={onSubmit}
						/>

						<button
							onClick={createO}
							type="button"
							className="button-small"
						>
							{collection_[locale].create_collection}
						</button>
					</>
				}
			>
				<Tabs
					default_={1}
					head={[
						collection_[locale].drafts,
						collection_[locale].published,
					]}
					body={[<Table {...prop} />, <Table {...prop} />]}
					setType={setType}
				/>
			</Card>
			<TemplateModal visible={createV} onClose={CloseC_}>
				{createV && (
					<CCreate type={type} initialVal={initial} close={CloseC} />
				)}
			</TemplateModal>
		</>
	);
};

export default Collection;
